import React from "react";
import styles from "./PriceCard.module.css";
import { GreenTickIcon, GreyTickIcon } from "../../assetLoader";
function PriceCard({
  type,
  price,
  credits,
  displayVNoFeature,
  displayUnlimitedCalling,
  displayCredits,
  country
}) {
  const featuresList = [
    {
      name: "1 Virtual number*",
      isPro: false,
      display: true,
    },
    {
      name: "Unlimited calling",
      isPro: false,
      display: displayUnlimitedCalling,
    },
    {
      name: `${credits} Credits`,
      isPro: false,
      display: displayCredits,
    },
    {
      name: "Call logs & reports",
      isPro: false,
      display: true,
    },

    { name: "Call recording", display: true, isPro: false },
    { name: "Mobile app", display: true, isPro: false },
    {
      name: "Click to call extension",
      isPro: false,
      display: true,
    },
    { name: "Custom reports", display: true, isPro: true },
    {
      name: "Incoming call routing",
      isPro: true,
      display: true,
    },
    {
      name: "Post call survey",
      isPro: true,
      display: country === "IND"
    },
    {
      name: "Call transfer",
      isPro: true,
      display: true
    }
  ];

  const handleChatOpen = () => {
    window?.HubSpotConversations?.widget?.open();
  };

  return (
    <div className={styles.price_card}>
      <h2>{type}</h2>

      <h1>{price}</h1>
      <p style={{ marginTop: "8px" }}>per user, per month.</p>
      <button className={styles.btn}>
        <a href="https://product.frejun.com/signup">Try for free</a>
      </button>
      <button className={styles.btnWhite} onClick={handleChatOpen}>
        Chat with sales
      </button>
      <div className={styles.seperator} />

      {featuresList.map((feature, index) => {
        if (!feature.display) return;
        return (
          <div key={index} className={styles.feature_list_item}>
            {feature.isPro && type === "STANDARD"
              ? GreyTickIcon()
              : GreenTickIcon()}
            <p
              style={{
                marginLeft: "12px",
                color:
                  feature.isPro && type === "STANDARD" ? "#C4D0DF" : "#4A4A4A",
              }}
            >
              {feature.name}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default PriceCard;
